module.exports = __webpack_public_path__ + "media/images/uos-crest-db8a457ad8f6f24a0e163e618b3c766f.svg";